var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switcher",class:{'slider-active': _vm.value}},[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }